import {
  ComponentRendering,
  HtmlElementRendering,
  getChildPlaceholder,
} from "@sitecore-jss/sitecore-jss-nextjs";

const COMPONENT_NAMES = {
  SEARCH_BAR: "Search Bar",
} as const;

const PLACEHOLDER_KEYS = {
  HEADLESS_MAIN: "headless-main",
  ASIDE: "sxa-cc-shared-aside",
} as const;

export function isComponentRendering(
  rendering: ComponentRendering | HtmlElementRendering,
): rendering is ComponentRendering {
  return typeof rendering === "object" && "componentName" in rendering;
}

function isSearchBarComponent(
  comp: ComponentRendering | HtmlElementRendering,
): comp is ComponentRendering {
  return (
    isComponentRendering(comp) &&
    comp.componentName === COMPONENT_NAMES.SEARCH_BAR
  );
}

export function getSearchComponent(
  rendering: ComponentRendering,
): ComponentRendering | undefined {
  const dynamicComponents = getChildPlaceholder(
    rendering,
    PLACEHOLDER_KEYS.HEADLESS_MAIN,
  );
  if (!dynamicComponents || dynamicComponents.length === 0) {
    return undefined;
  }

  for (const dynamicComponent of dynamicComponents) {
    if (!isComponentRendering(dynamicComponent)) {
      continue;
    }
    const asideComponents = getChildPlaceholder(
      dynamicComponent,
      PLACEHOLDER_KEYS.ASIDE,
    );
    if (!asideComponents || asideComponents.length === 0) {
      continue;
    }
    const searchComponent = asideComponents.find(isSearchBarComponent);
    if (searchComponent) {
      return searchComponent;
    }
  }

  return undefined;
}
